var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h6',[_vm._v(_vm._s(_vm.$t("disposal-method.text")))]),_c('LibraryItems',{attrs:{"rightPanelId":"sidebar-new-data-disposal-method","organizationScopedState":"dataDisposalMethod","libraryScopedState":"disposalMethod","hideCategoryFilter":true,"hideSaveAs":true},on:{"interceptForSetParent":_vm.interceptForSetParent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }